import { Stack, Typography, useTheme } from '@mui/material';

import MapIcon from '@mui/icons-material/Map';
import { ATSApplicantProfileTestIds } from 'data-testids/ATS';
import { WorkEligibilityBadgeProps } from './types';
import { WorkEligibilityText } from './enums';

export const WorkEligibilityBadge: React.FC<WorkEligibilityBadgeProps> = ({ isEligible }) => {
  const theme = useTheme();

  const getWorkEligibilityBadgeText = () => {
    if (isEligible) {
      return WorkEligibilityText.HAS_AUTHORIZATION;
    } else if (isEligible === false) {
      return WorkEligibilityText.DOES_NOT_HAVE_AUTHORIZATION;
    }

    return WorkEligibilityText.UNREPORTED_AUTHORIZATION;
  };

  const getWorkEligibilityIconColor = () => {
    if (isEligible === true) {
      return theme.palette.primary.main;
    } else if (isEligible === false) {
      return theme.palette.error.main;
    }

    return theme.palette.yellow.main;
  };

  return (
    <Stack direction="row" data-testid={ATSApplicantProfileTestIds.WORK_ELIGIBILITY_BADGE}>
      <MapIcon
        data-testid={ATSApplicantProfileTestIds.ELIGIBILITY_ICON}
        sx={{ fill: getWorkEligibilityIconColor() }}
      />
      <Typography
        data-testid={ATSApplicantProfileTestIds.ELIGIBILITY_STATUS_TEXT}
        sx={{
          paddingLeft: '7px',
          color: theme.palette.black.main,
          fontWeight: theme.typography.fontWeightMedium,
          fontSize: '15px',
        }}
      >
        {getWorkEligibilityBadgeText()}
      </Typography>
    </Stack>
  );
};
